import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MuiAlert from '@mui/material/Alert';
import MuiAlertTitle from '@mui/material/AlertTitle';
import * as React from 'react';
import { FlexBox } from '../box';
import { IconButton } from '../button';
import { IconContentCopy } from '../icon';
import { Link } from '../link';
import { styled } from '../styled';
import { getPaletteColor } from '../theme/color-utils';
import { Tooltip } from '../tooltip';
import { deepMerge, makeEnum, withVersion } from '../utils';
export { MuiAlertTitle as AlertTitle };
export const AlertSeverity = makeEnum('error', 'info', 'success', 'warning');
const StyledMuiAlert = styled(MuiAlert)(({ theme, $severity }) => ({
    width: '100%',
    boxSizing: 'border-box',
    backgroundColor: getPaletteColor(theme, `components.alert.${$severity}.background`),
    color: getPaletteColor(theme, `components.alert.${$severity}.color`),
    '& .MuiAlert-icon': {
        color: getPaletteColor(theme, `components.alert.${$severity}.color`)
    }
}));
const ErrorIdContainer = styled(FlexBox)(({ theme, $severity }) => ({
    alignItems: 'center',
    gap: theme.spacing(0.5),
    marginTop: theme.spacing(1),
    color: getPaletteColor(theme, `components.alert.${$severity}.color`),
    fontSize: theme.typography.caption.fontSize,
    fontWeight: theme.typography.caption.fontWeight
}));
export const Alert = withVersion(React.forwardRef((props, ref) => {
    const { errorId, errorIdLabel, copyTooltip, copiedTooltip, items, iconAlign, children, ...rest } = props;
    const [copied, setCopied] = React.useState(false);
    const slotProps = deepMerge({}, rest.slotProps ?? {}, {
        icon: {
            sx: {
                alignItems: iconAlign ?? 'inherit'
            }
        }
    });
    const handleCopyErrorId = async () => {
        if (!errorId) {
            return;
        }
        await navigator.clipboard.writeText(errorId);
        setCopied(true);
        await new Promise((resolve) => setTimeout(resolve, 2000));
        setCopied(false);
    };
    return (_jsxs(StyledMuiAlert, { ...rest, ref: ref, slotProps: slotProps, "$severity": rest.severity, children: [children, items && items.length > 0 && (_jsx("ul", { children: items.map((item) => (_jsx("li", { children: item.isLink || item.href ? (_jsx(Link, { href: item.href ?? '#', target: "_blank", rel: "noopener noreferrer", color: "inherit", underline: "always", sx: { textDecorationColor: 'inherit' }, children: item.value })) : (item.value) }, item.value))) })), errorId && (_jsxs(ErrorIdContainer, { "data-role": "alert-error-id", "$severity": rest.severity, children: [_jsx(Tooltip, { ...(copied ? { open: true } : {}), title: copied
                            ? (copiedTooltip ?? 'Copied!')
                            : (copyTooltip ?? 'Copy code'), children: _jsx(IconButton, { size: "small", color: "inherit", onClick: handleCopyErrorId, "aria-label": copyTooltip ?? 'Copy code', children: _jsx(IconContentCopy, { color: "inherit" }) }) }), errorIdLabel ?? 'Error ID', ": ", errorId] }))] }));
}), '1.1.0');
